<template>
  <el-form ref="form" class="image-form" :model="form" :rules="rules">
    <el-form-item prop="images" :class="{'showSearchImg': showSettingSearchImgBtn}">
      <div class="ft-12">
        <span v-if="showStart" style="color: red">*</span>商品展示图
        <BatchEditImages 
          v-model="form.images" 
          @change="handleImageChanged" 
          refName="images" 
          :getWidthAndHeights="getWidthAndHeights"
        >
        </BatchEditImages>
      </div>
      <MutiImgUpload
        ref="images"
        v-model="form.images"
        :limitSize="5 * 1024 * 1024"
        :size="200"
        :limitWidth="[600, 800]" 
        :limitHeight="[600, 800]" 
        :mainImgNums="0"
        :limitNums="10"
        :colorId="colorId"
        limitSuffix=".jpg,.jpeg,.png"
        @change="handleImageChanged"
        @imageUrlSetChanged="handleImageSetChanged"
      />
    </el-form-item>
    <el-form-item style="margin-top:16px">
      <p class="tips ft-12">
        图片至少上传1张，最多10张，大小不超过5M，尺寸不得低于600px*600px，仅支持jpg、jpeg、png格式，您可以拖拽图片调整顺序
      </p>
    </el-form-item>
  </el-form>
</template>

<script>
// jd商品图片块

import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import ImgUpload from "@/components/Uploads/ImgUpload";
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'

export default {
  components: {
    MutiImgUpload,
    ImgUpload,
    BatchEditImages
  },
  model: {
      prop: 'value',
      event: 'change'
  },
  props: {
    value: Array,
    colorId: [String, Number],
    showSettingSearchImgBtn:Boolean,
    imagesLength: Number,
  },
  data() {
    const valiImages = async (rule, value, cb) => {
      const len = value ? value.length : 0;
      let hasErrorImg = false;
      value && value.forEach(item => {
        if (typeof item === 'object') {
          hasErrorImg = true
        }
      })
      if (hasErrorImg) {
        return cb(new Error('请移除相关失败图片或正在上传的图片'))
      }
      if (len < 1 || len > 10) {
        return cb(new Error('图片至少上传1张，最多10张'))
      } else if (this.$refs.images) {
        let errMsg = await this.$refs.images.method_validImage()
        if (errMsg) {
            cb(new Error(errMsg));
        } else {
            cb();
        }
      } else {
        cb()
      }
    }
    return {
      form: {},
      rules: {
        images: [
          {validator: valiImages}
        ],
      },
      showStart: true,
    }
  },
  watch: {
    value: {
      handler(v) {
        this.$set(this.form, 'images', v)
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    getData() {
      return [JSON.parse(JSON.stringify(this.form.images))]
    },
    setData([images] = [[], '']) {
      this.$set(this.form, 'images', images)
    },
    handleImageChanged() {
      this.$emit('change',this.form.images)
    },
    handleImageSetChanged(checkedImgObj) {
      this.$emit('grandparentImageUrlSetChanged', checkedImgObj)
    },
  }
}
</script>

<style lang="scss" scoped>
.image-form {
  background: #f5f7f9;
  padding: 5px 15px;
}
.tips {
  color: #9ca7b6 !important;
}
.showSearchImg{
  ::v-deep .el-form-item__error{
    top: 136%;
  }
}
</style>